var _style, _circle, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#D80027;}\n\t.st3{fill:#FFDA44;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c77.6,0,147.1-34.5,194.1-89H61.9C108.9,477.5,178.4,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512,256C512,114.6,397.4,0,256,0S0,114.6,0,256c0,23.1,3.1,45.5,8.8,66.8h494.4 C508.9,301.5,512,279.1,512,256z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.3,356.2c4.9,11.6,10.7,22.7,17.2,33.4h436.9c6.5-10.6,12.3-21.8,17.2-33.4H20.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183,272.7l4.1,12.8h13.4l-10.8,7.9l4.1,12.8l-10.9-7.9l-10.9,7.9l4.1-12.8l-10.8-7.9h13.4L183,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183,439.7l4.1,12.8h13.4l-10.8,7.9l4.1,12.8l-10.9-7.9l-10.9,7.9l4.1-12.8l-10.8-7.9h13.4L183,439.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.3,383.2l4.1,12.8h13.4l-10.8,7.9l4.1,12.8l-10.8-7.9l-10.8,7.9l4.1-12.8l-10.8-7.9h13.4L105.3,383.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135,289.4l4.1,12.8h13.4l-10.8,7.9l4.1,12.8l-10.9-7.9l-10.8,7.9l4.1-12.8l-10.9-7.9h13.4L135,289.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.7,341.9l13.4,0l4.1-12.8l4.1,12.8l13.4,0l-10.8,7.9l4.1,12.8l-10.9-7.9l-10.8,7.9l4.1-12.8L87.7,341.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.1,453.9l4.1-12.8l-10.9-7.9h13.4l4.1-12.8l4.1,12.8h13.4l-10.9,7.9l4.1,12.8L135,446L124.1,453.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M260.7,383.2l-4.1,12.8h-13.4l10.8,7.9l-4.1,12.8l10.8-7.9l10.9,7.9l-4.1-12.8l10.9-7.9h-13.4L260.7,383.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M231,289.4l-4.1,12.8h-13.4l10.8,7.9l-4.1,12.8l10.9-7.9l10.9,7.9l-4.1-12.8l10.9-7.9h-13.4L231,289.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M278.2,341.9l-13.4,0l-4.1-12.8l-4.1,12.8l-13.4,0l10.8,7.9l-4.1,12.8l10.9-7.9l10.8,7.9l-4.1-12.8 L278.2,341.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M241.8,453.9l-4.1-12.8l10.9-7.9h-13.4l-4.1-12.8l-4.1,12.8h-13.4l10.9,7.9l-4.1,12.8L231,446L241.8,453.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.f1e53a71988f62fb00fc1f11e3f63ec0.svg";
export { ForwardRef as ReactComponent };